<template>
  <div v-if="property?.id" class="property-page">
    <property-details-card
      :property="property"
      :me="me"
      :refreshTable.sync="dataChanged"
    ></property-details-card>

    <v-row>
      <v-col cols="6">
        <google-map
          :center="{
            lat: propertiesInView[0].latitude,
            lng: propertiesInView[0].longitude,
          }"
          :initial="propertiesInView"
          :loading.sync="loading"
          v-if="propertiesInView"
        />
      </v-col>
      <v-col cols="6">
        <property-media :id="id" :media.sync="media" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <suburb-trends-with-notes
          v-if="property?.id"
          :property-id="property.id"
          :suburb-trends="property.suburbTrends"
          :type="property.ownershipType"
          :notes-id="property.id"
          field-name="notes"
          query="property"
        />
      </v-col>
    </v-row>

    <property-buildings
      :property="property"
      :me="me"
      :dataChanged.sync="dataChanged"
      :outerDatachange="dataChanged"
    />
  </div>
</template>

<script>
import PropertyDetailsCard from "@/components/Base/Property/PropertyLanding/PropertyDetailsCard";
import GoogleMap from "@/components/Base/Property/PropertyLanding/GoogleMapsMini";
import SuburbTrendsWithNotes from "@/components/SuburbTrendsWithNotes.vue";
import PropertyMedia from "@/components/Base/Property/PropertyBlocks/PropertyMedia";
import PropertyBuildings from "@/components/Base/Property/PropertyLanding/PropertyBuildings";

import { GET_PROPERTY_POLYGONS, GET_ONE_PROPERTY } from "@/queries/property";
import { gql } from "apollo-boost";

export default {
  name: "PropertyLanding",
  components: {
    PropertyDetailsCard,
    SuburbTrendsWithNotes,
    GoogleMap,
    PropertyMedia,
    PropertyBuildings,
  },
  data() {
    return {
      loading: false,
      dataChanged: null,
      media: null,
      center: null,
      propertiesInView: null,
    };
  },
  apollo: {
    me: gql`
      query {
        me {
          id
          role
        }
      }
    `,
    property: {
      query: GET_ONE_PROPERTY,
      fetchPolicy: "network-only",
      skip() {
        return !this.id;
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data }) {
        this.center = {
          lat: data.property.latitude,
          lng: data.property.longitude,
        };
      },
    },
    properties: {
      query: GET_PROPERTY_POLYGONS,
      fetchPolicy: "cache-first",
      skip() {
        return !(this.id && this.property);
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      variables() {
        const latitude = {
          latitude: {
            $gte: this.center.lat - 0.007,
            $lte: this.center.lat + 0.007,
          },
        };

        const longitude = {
          longitude: {
            $gte: this.center.lng - 0.007,
            $lte: this.center.lng + 0.007,
          },
        };

        const query = {
          $and: [latitude, longitude, { _id: { $ne: this.id } }],
        };

        query.fieldLimit =
          "_id name address latitude longitude pinColor polygon";

        // make better by using google maps and getting by bounds and removing this
        return {
          limit: 0,
          skip: 0,
          query: query,
          sort: null,
        };
      },
      result({ data }) {
        var items = data?.properties.records.concat([this.property]);
        items.map((e) => {
          e.lat = parseFloat(e.latitude);
          e.lng = parseFloat(e.longitude);

          return e;
        });

        this.propertiesInView = items;
      },
    },
  },
  watch: {
    dataChanged() {
      this.$apollo.queries.property.refetch();
      this.$apollo.queries.properties.refetch();
    },
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
};
</script>

<style scoped></style>
